import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-client-income-estimation-autocomplete',
  templateUrl: './client-income-estimation-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class ClientIncomeEstimationAutocompleteComponent {
  @Input() placeholder: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;
  isManualInputClientConfirmed: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {}

  getAllItems(): any {
    this.getAllClients();
  }

  getAllClients(): void {
    this.sharedService.getClientsForIncomeEstimation(this.input).subscribe(
      res => {
        this.items = [];

        res.results.forEach(item => {
          this.items.push(item);
        });
        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(item: any, manual: boolean = false): any {
    const isObject = item && typeof item === 'object' && 'name' in item;
  
    const selectedItem = isObject ? item : { name: item };
    this.input = selectedItem.name;
    this.selected.emit({ ...selectedItem, manual });
    this.isListVisible = false;
    this.isManualInputClientConfirmed = true;
  }

  onManualInput(): void {
    const trimmedInput = this.input?.trim();
  
    if (!trimmedInput) return;
  
    const existingItem = this.items.find(item => item.name === trimmedInput);
    if (!existingItem) {
      this.onSelect({ name: trimmedInput, clientId: null }, true);
    }

    this.isManualInputClientConfirmed = true;
  }

  onInputChange(): void {
    this.isManualInputClientConfirmed = false;
  }

  trackByFn(index: number): number {
    return index;
  }
}